module.exports = __webpack_public_path__ + "static/media/cgoods.b0fdf356.svg";